// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4196":"744c2781b515aaa5","4831":"6ea0925f1863338b","7617":"ce75c75d3393476c","7978":"bdef1783bc9e1e00"}[chunkId] + ".css";
};